var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pricing-option-property"},[_c('span',[_vm._v(_vm._s(_vm.option.key))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.option.value))])])}
var staticRenderFns = []

export { render, staticRenderFns }